import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-locale';

const useTranslateDefaultOptions = ({ isEmsAccount }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const options = useMemo(() => {
    const DEFAULT_OPTION_COMPANIES = {
      id: 'UNSELECTED_OPTION',
      name: T.translate('VALUE_FROM_ACCOUNT_ADMIN'),
      status: '',
      description: T.translate('DEFAULT_OPTION_COMPANY_DESCRIPTION'),
    };

    const DEFAULT_OPTION_ROLES = {
      id: 'UNSELECTED_OPTION',
      name: isEmsAccount
        ? T.translate('VALUE_FROM_HUB_ADMIN')
        : T.translate('VALUE_FROM_ACCOUNT_ADMIN'),
      status: '',
      description: isEmsAccount
        ? T.translate('DEFAULT_OPTION_ROL_DESCRIPTION_EMS')
        : T.translate('DEFAULT_OPTION_ROL_DESCRIPTION'),
    };

    return {
      DEFAULT_OPTION_COMPANIES,
      DEFAULT_OPTION_ROLES,
    };
  }, [T, isEmsAccount]);

  return options;
};

useTranslateDefaultOptions.propTypes = {
  isEmsAccount: PropTypes.bool,
};

useTranslateDefaultOptions.defaultProps = {
  isEmsAccount: false,
};

export default useTranslateDefaultOptions;
